import xior from 'xior';

const descriptionApi = xior.create({
  baseURL: 'https://goods.neuralgeneration.com',
});

export interface DescriptionResponse {
  lang: string;
  desc: string;
  name: string;
}

export const getDescription = async (
  name: string,
  lang: string = 'en',
): Promise<DescriptionResponse> => {
  const response = await descriptionApi.get('/api/goods/fetch_description', {
    params: {
      name,
      lang,
    },
  });

  return response.data;
};
